
import { ref, computed } from 'vue'

import icons from '../images/icons/*.svg'

import payload from './payload'

import nationalAverage from './national-average'

export const populationHealthReference = 3

export default ref ( [ {

  id: 1,

  icon: icons[ 'heart-disease' ],

  statistic: 'heart disease',

  localValue: computed( () => payload.value?.places?.chd_crude_prev ),
  
  nationalValue: computed( () => nationalAverage.value?.places?.chd_crude_prev.toFixed( 1 ) ),

  alert: computed( () => payload.value?.places?.chd_crude_prev > nationalAverage.value?.places?.chd_crude_prev )

}, {

  id: 2,

  icon: icons[ 'cancer' ],

  statistic: 'cancer',
  
  localValue: computed( () => payload.value?.places?.cancer_crude_prev ),

  nationalValue: computed( () => nationalAverage.value?.places?.cancer_crude_prev.toFixed( 1 ) ),
  
  alert: computed( () => payload.value?.places?.cancer_crude_prev > nationalAverage.value?.places?.cancer_crude_prev )

}, {

  id: 3,

  icon: icons[ 'diabetes' ],

  statistic: 'diabetes',

  localValue: computed( () => payload.value?.places?.diabetes_crude_prev ),

  nationalValue: computed( () => nationalAverage.value?.places?.diabetes_crude_prev.toFixed( 1 ) ),

  alert: computed( () => payload.value?.places?.diabetes_crude_prev > nationalAverage.value?.places?.diabetes_crude_prev )
  
}, {

  id: 4,

  icon: icons[ 'obesity' ],

  statistic: 'obesity',

  localValue: computed( () => payload.value?.places?.obesity_crude_prev ),

  nationalValue: computed( () => nationalAverage.value?.places?.obesity_crude_prev.toFixed( 1 ) ),

  alert: computed( () => payload.value?.places?.obesity_crude_prev > nationalAverage.value?.places?.obesity_crude_prev )

}, {

  id: 5,

  statistic: 'high cholesterol',
  
  icon: icons[ 'high-cholesterol' ],

  localValue: computed( () => payload.value?.places?.highchol_crude_prev ),

  nationalValue: computed( () => nationalAverage.value?.places?.highchol_crude_prev.toFixed( 1 ) ),

  alert: computed( () => payload.value?.places?.highchol_crude_prev > nationalAverage.value?.places?.highchol_crude_prev )

}, {

  id: 6,

  statistic: 'high blood pressure',
  
  icon: icons[ 'high-blood-pressure' ],

  localValue: computed( () => payload.value?.places?.bphigh_crude_prev ),

  nationalValue: computed( () => nationalAverage.value?.places?.bphigh_crude_prev.toFixed( 1 ) ),

  alert: computed( () => payload.value?.places?.bphigh_crude_prev > nationalAverage.value?.places?.bphigh_crude_prev )

} ] )